import React, { useState } from 'react';
import AgentRosterInput from '../../../react-common/AgentRosterInput';
import Step1CustomContactForm from './Step1CustomContactForm';
import Step1IntCustomContact from './Step1IntCustomContact';
import Step1SelectedUser from './Step1SelectedUser';

const Step1IntMainForm = ({
  appointment,
  appointmentTypes,
  bookFor,
  customContact,
  customContactForm,
  customContactPreApproved,
  customContactSaved,
  extAuth,
  isBookingVirtualTour,
  isMobile,
  listing,
  naTypeMap,
  nextStepLabel,
  nonAgent,
  nonAgentId,
  nonAgentTypes,
  customAgent,
  customAgentId,
  sameOrg,
  selectedUser,
  haveListingPermission,
  inviteBuyers,
  setInviteBuyers,
  // functions
  isValidContact,
  customContactEdit,
  deleteCustomAgentOrContact,
  updateState,
  selectCustomContact,
  selectSearchRoster,
  selectUser,
  selectNonAgent,
  selectCustomAgent,
  resetDate,
  deselectUser,
  deselectNonAgent,
  selectNotifyMethod,
  // angularjs
  $rootScope,
  AppointmentBookService,
  ErrorService,
  showingOverrideType,
}) => {
  // Custom contact / NonAgent form save to be submitted
  const customContactSave = values => {
    updateState(draft => {
      if (!draft.customContactForm) draft.customContactForm = {};
      draft.customContactForm.submitted = true;
    });

    updateState(draft => {
      draft.dataLoaded = false;
    });

    if (bookFor === 'nonAgent') {
      updateState(draft => {
        draft.nonAgentId = (draft.nonAgent && draft.nonAgent.id) || '';
        draft.customContact.isNotAgent = true;
        draft.nonAgent = {
          id: nonAgentId || '',
          type: draft.appointment.type,
          firstName: draft.customContact.firstName,
          lastName: draft.customContact.lastName,
          email: draft.customContact.email,
          phone: draft.customContact.phone,
          companyAddress: draft.customContact.org.address,
          companyName: draft.customContact.org.name,
          companyPhone: draft.customContact.org.phone,
        };
      });
      const { naType: type, ...nonAgentValues } = values;
      const saveNonAgentValues = { type, ...nonAgentValues };

      AppointmentBookService.saveNonAgent(nonAgentId, saveNonAgentValues)
        .then(newNonAgent => {
          updateState(draft => {
            draft.customContact.nonAgentId = newNonAgent.id;
            draft.nonAgentId = newNonAgent.id;
            draft.nonAgent.id = newNonAgent.id;
            draft.customContactSaved = true;
            draft.dataLoaded = true;
          });
          resetDate();
        })
        .catch(err => {
          ErrorService.toastyHTTPErr(err);
        });
    } else if (bookFor === 'others') {
      updateState(draft => {
        draft.customAgent = {
          type: draft.appointment.type,
          firstName: draft.customContact.firstName,
          lastName: draft.customContact.lastName,
          email: draft.customContact.email,
          phone: draft.customContact.phone,
          companyAddress: draft.customContact.org.address,
          companyName: draft.customContact.org.name,
          companyPhone: draft.customContact.org.phone,
        };
      });
      const saveCustomAgentValues = {
        ...values,
        listingId: listing.id,
        id: customAgentId,
      };
      delete saveCustomAgentValues.type;

      AppointmentBookService.saveCustomAgent(
        customAgentId,
        saveCustomAgentValues,
      ).then(newCustomAgent => {
        updateState(draft => {
          draft.customContact.customAgentId = newCustomAgent.id;
          draft.customAgent.id = newCustomAgent.id;
          draft.customAgentId = newCustomAgent.id;
          draft.customContactSaved = true;
          draft.dataLoaded = true;
          draft.customAgent = {
            id: newCustomAgent.id,
            firstName: newCustomAgent.firstName,
            lastName: newCustomAgent.lastName,
            email: newCustomAgent.email,
            phone: newCustomAgent.phone,
            companyName: newCustomAgent.companyName,
            companyPhone: newCustomAgent.companyPhone,
            companyAddress: newCustomAgent.companyAddress,
            createdBy: newCustomAgent.createdBy,
          };
        });
      });
    } else {
      updateState(draft => {
        draft.customContactSaved = true;
        draft.dataLoaded = true;
      });
      resetDate();
    }
  };

  const [showNote, setShowNote] = useState(false);
  return (
    <div className="form-group">
      <div className="row">
        <div className="col-md-12">
          {!customContact && !extAuth && (
            <span>
              <label>{bookFor === 'nonAgent' ? 'Search' : 'Agent'} Name</label>
              {!isBookingVirtualTour && haveListingPermission && (
                <a
                  className="pull-right"
                  onClick={selectCustomContact}
                  data-cy="enter-custom-contact"
                >
                  Enter Custom Contact
                </a>
              )}
            </span>
          )}
          {customContact && !customContactSaved && (
            <a
              className="pull-right"
              onClick={selectSearchRoster}
              style={{ marginBottom: '5px' }}
            >
              Search Roster
            </a>
          )}
        </div>
      </div>

      {/* The agent/appraiser/homeinspector/customAgent input */}
      {(!customContact || customContactSaved) && bookFor !== 'self' && (
        <div style={{ height: '100%' }}>
          <AgentRosterInput
            nonAgent={bookFor === 'nonAgent'}
            selectUser={bookFor === 'nonAgent' ? selectNonAgent : selectUser}
            deselectUser={
              bookFor === 'nonAgent' ? deselectNonAgent : deselectUser
            }
            auth={$rootScope.auth}
            listingId={listing.id}
            isBookShowings
            isMobile={isMobile}
            selectCustomAgent={selectCustomAgent}
            includeCustomAgents
          />
        </div>
      )}

      {/* Displays the saved custom contact  */}
      {customContact && customContactSaved && (
        <Step1IntCustomContact
          nonAgent={nonAgent}
          customContact={customContact}
          naTypeMap={naTypeMap}
          appointment={appointment}
          selectSearchRoster={selectSearchRoster}
          bookFor={bookFor}
          customContactEdit={customContactEdit}
          deleteCustomAgentOrContact={deleteCustomAgentOrContact}
          updateState={updateState}
          auth={$rootScope.auth}
          customAgent={customAgent}
          preApproved={customContactPreApproved}
          appointmentTypes={appointmentTypes}
        />
      )}

      {/* Form to enter custom contact */}
      {customContact && !customContactSaved && (
        <Step1CustomContactForm
          bookFor={bookFor}
          customContact={customContact}
          customContactSaved={customContactSaved}
          customContactForm={customContactForm}
          naTypeMap={naTypeMap}
          nonAgentId={nonAgentId}
          nextStepLabel={nextStepLabel}
          nonAgentTypes={nonAgentTypes}
          nonAgent={nonAgent}
          customContactSave={customContactSave}
          customContactEdit={customContactEdit}
          deleteCustomAgentOrContact={deleteCustomAgentOrContact}
          resetDate={resetDate}
          isValidContact={isValidContact}
          selectSearchRoster={selectSearchRoster}
          updateState={updateState}
          appointmentTypes={appointmentTypes}
          AppointmentBookService={AppointmentBookService}
          ErrorService={ErrorService}
        />
      )}

      {/* Displays selected user */}
      {selectedUser && (
        <Step1SelectedUser
          updateState={updateState}
          selectedUser={selectedUser}
          appointment={appointment}
          customContactSaved={customContactSaved}
          bookFor={bookFor}
          sameOrg={sameOrg}
          customContact={customContact}
          showNote={showNote}
          setShowNote={setShowNote}
          appointmentTypes={appointmentTypes}
          listing={listing}
          selectNotifyMethod={selectNotifyMethod}
          showingOverrideType={showingOverrideType}
          inviteBuyers={inviteBuyers}
          setInviteBuyers={setInviteBuyers}
          auth={$rootScope.auth}
          $rootScope={$rootScope}
        />
      )}
    </div>
  );
};

export default Step1IntMainForm;
